import { MobilePermissionEnum } from 'constants-permissions';
import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../IntegrationDefinition';
import { PackagedTypeEnum } from '../../properties/PackagedTypeEnum';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

export enum CardFormatEntity {
  Symmetric = 'SYMMETRIC',
  Aliro = 'ALIRO',
}

export type CardFormatOption = {
  _id: string;
  _order: number;
  name: string;
  value: CardFormatEntity;
};

export const CardFormatDropdownOptions: Array<CardFormatOption> =
  [
    {
      _id: 'symmetric',
      _order: 0,
      name: 'Symmetric',
      value: CardFormatEntity.Symmetric,
    },
    {
      _id: 'aliro',
      _order: 1,
      name: 'Aliro',
      value: CardFormatEntity.Aliro,
    },
  ];

const KastleDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Kastle,
  hasCustomUI: true,
  friendlyName: 'Kastle Access Control',
  description: `Defines the properties required for a Kastle integration.`,
  category: IntegrationCategoryEnum.AccessControl,
  platforms: [PlatformEnum.Mobile],
  type: IntegrationTypeEnum.SDK,
  settings: {},
  properties: {
    supportPage: {
      friendlyName: 'Support Page',
      type: 'Content',
    },
    cardFormat: {
      hidden: false,
      packagedType: PackagedTypeEnum.Dropdown,
      type: 'Option',
      friendlyName: 'Access Credential Type',
      description: 'web.admin.channel.integrations.kastle.cardFormat.description',
      validators: [{ name: 'In', value: CardFormatDropdownOptions }],
    },
    isAppleWalletEnabled: {
      hidden: false,
      type: 'Boolean',
      friendlyName: 'Enable Apple Wallet',
      default: false,
    },
    isGoogleWalletEnabled: {
      hidden: false,
      type: 'Boolean',
      friendlyName: 'Enable Google Wallet',
      default: false,
    },
  },
  mobilePermissions: [
    MobilePermissionEnum.Bluetooth,
    MobilePermissionEnum.ScheduleExactAlarm,
    MobilePermissionEnum.Location,
    MobilePermissionEnum.AlwaysLocation,
    MobilePermissionEnum.AccessFineLocation,
  ],
  // Google requires us to use specific language requesting background location access before we load the system prompts
  mobilePermissionsRequest:
    'mobile.access.integration.kastle.definition.mobilePermissionsRequest',
};

export const definition = KastleDefinition;
